import React from 'react';
import { movementTexts } from '../contexts/LangHO2';
import movementImg from '../assets/images/halcyon/movement.png';


function ProductHOMovement2({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {/* 제목 */}
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 20 : 30,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        letterSpacing: '-0.02em',
        textAlign: 'center',
        width: '100%'
      }}>
        {movementTexts.title[lang]}
      </span>
      
      {/* 콘텐츠 영역 - 이미지만 표시 */}
      <div style={{
        width: '100%',
        padding: isMobile ? '0 20px 40px 20px' : '0 40px 40px 40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={movementImg}
          alt="Security Operations Movement"
          style={{
            maxWidth: isMobile ? '300px' : '1200px',
            width: '100%',
            height: 'auto',
            objectFit: 'contain'
          }}
        />
      </div>
    </div>
  );
}

export default ProductHOMovement2;